<rcp-com-card
    cardClass="bg-white border border-gray-border"
    [hasHeader]="false">
    <div
        class="flex flex-col h-full p-4"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        <h6 class="font-semibold uppercase mb-3">
            Aging Trend
            <span class="text-sm text-gray-500"
                >(Today Compared To Last Month)</span
            >
        </h6>
        <div class="grid grid-cols-2 gap-3">
            <div>
                <div class="font-semibold">> 30 Days</div>
                <div class="flex flex-row gap-1">
                    <span class="font-semibold text-[22px] flex-none"
                        >{{ age30PlusPercent }}%</span
                    >
                    <div
                        class="flex flex-row items-end gap-1 grow shrink-0 {{
                            age30DifferenceClass
                        }}">
                        <span>
                            @if (age30PlusTrend === TREND_DIRECTION.NEGATIVE) {
                                <i class="fa-solid fa-arrow-trend-down"></i>
                            } @else if (
                                age30PlusTrend === TREND_DIRECTION.POSITIVE
                            ) {
                                <i class="fa-solid fa-arrow-trend-up"></i>
                            }
                        </span>
                        <span>{{ age30PlusDifference }}</span>
                    </div>
                </div>
            </div>
            <div>
                <div class="font-semibold">> 60 Days</div>
                <div class="flex flex-row gap-1">
                    <span class="font-semibold text-[22px] flex-none"
                        >{{ age60PlusPercent }}%</span
                    >
                    <div
                        class="flex flex-row items-end gap-1 grow shrink-0 {{
                            age60DifferenceClass
                        }}">
                        <span>
                            @if (age60PlusTrend === TREND_DIRECTION.NEGATIVE) {
                                <i class="fa-solid fa-arrow-trend-down"></i>
                            } @else if (
                                age60PlusTrend === TREND_DIRECTION.POSITIVE
                            ) {
                                <i class="fa-solid fa-arrow-trend-up"></i>
                            }
                        </span>
                        <span>{{ age60PlusDifference }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</rcp-com-card>
